module.exports = __webpack_public_path__ + "static/media/mobile-alt.2eb78e56.svg";